import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

const register = () => {
  Logger.log('debug', `adminPartnerClasses.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'adminPartnerClasses', 'routes'])) {
    Events.dispatch('ADD_MAIN_ROUTES', 
      {
      }
    );
  }
}

export default register;

Logger.log('silly', `adminPartnerClasses.register() loaded.`);
